var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.paymentList),function(payment,index){return [_c('PaymentHistoryListItem',{key:payment.uuid,attrs:{"isOdd":index % 2 ? true : false,"payment":payment}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }